import { Table, OptionsDataType, ColDataType, RowDataType } from "@thrivetribe/mvf.ui.organisms.table";
import { ClubStats as ClubStatsProp } from "types/Legacy/ClubStats";
import "./League.scss";

const options: OptionsDataType = {
  tableAriaLabel: "League Table",
  headerSticky: true,
  headerEl: <h2>League Table</h2>,
  headerColTopOffset: 48,
};

const columns: ColDataType[] = [
  { id: "id", label: "#", align: "center" },
  { id: "team", label: "Team" },
  { id: "played", label: "PL", align: "center" },
  { id: "won", label: "W", align: "center" },
  { id: "points", label: "PTS", align: "center" },
];

interface CustomRowDataType extends RowDataType {
  id?: number;
  team?: JSX.Element;
  played?: number;
  won?: number;
  points?: number;
}
interface LeagueProps {
  stats: ClubStatsProp | undefined;
}
export const League = ({ stats }: LeagueProps): JSX.Element => {
  const leagueData = stats?.LeagueFixtureStats_WeightGoal ?? [];

  const rows: CustomRowDataType[] = leagueData.map(
    ({ TeamName, TeamTotalPlayed_P, TeamTotalWon_W, TeamTotalPts_Pts }: any, index: number) => {
      const data = {
        id: index + 1,
        team: <span>{TeamName}</span>,
        played: TeamTotalPlayed_P,
        won: TeamTotalWon_W,
        points: TeamTotalPts_Pts,
        options: {
          hoverDisabled: true,
        },
      };
      return data;
    }
  );

  if (rows.length < 8) {
    const missingRowCount = 8 - rows.length;
    const missingRows: CustomRowDataType[] = [];

    for (let i = 0; i < missingRowCount; i++) {
      missingRows.push({
        team: <>&nbsp;</>,
        options: { renderCellsWhenUndefined: true, hoverDisabled: true },
      });
    }
    rows.push(...missingRows);
  }

  return (
    <article className="league-table">
      <Table<CustomRowDataType> options={options} columns={columns} rows={rows} />
    </article>
  );
};
